'use strict';

angular.module('licensure.services')
    .factory('FBQuestionTypes', ['$http', '$q', function ($http, $q) {
        return {
            get: function (formID) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/FBQuestionTypes', {
                    params: {
                        formID: formID
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });
                
                return d.promise;
            }
        }
    }])
;